export const JOB_STATUS_LABELS = {
  open: 'Aberta',
  scheduled: 'Agendada',
  inProgress: 'Em andamento',
  closed: 'Finalizada',
  expired_no_show: 'Tempo máximo atingido',
};

export const APPLICATION_STATUS_LABELS = {
  pending: 'Pendente',
  approved: 'Aprovado',
  rejected: 'Recusado',
  completed: 'Concluído',
  early_exit: 'Saída antecipada',
  invited: 'Convite recebido',
  expired: 'Expirada (vaga fechada)',
};

export function translateJobStatus(status) {
  return JOB_STATUS_LABELS[status] || status;
}

export function translateApplicationStatus(status) {
  return APPLICATION_STATUS_LABELS[status] || status;
}